/**
 * @file CircleLoadingState.tsx
 * @description
 * -----------------------------------------------------
 * Componente de carga
 * -----------------------------------------------------
 * @version 1.0.0a
 * @created 2025-08-27
 * @author Correcta
 * @author Cristina Bosa
 * @copyright © Correcta
 * @license Private
 * */

export const CircleLoadingState = () => {
  return (
    <section className="loader">
      <section className="loader__circular-container">
        <section className="loader__circular"></section>
      </section>
    </section>
  );
};
